import { remoteUrl } from "../../helpers/UrlHelpers";

const CARTOON_DRAW_URL  = process.env.REACT_APP_CARTOONDRAW_URL;

function categoryPath(this: any, target_id: number, id: number ) {
  let target;

  switch (target_id) {
    case 1:
      target = 'skins';
      break;
    case 2:
      target = 'worlds';
      break;
    case 3:
      target = 'addon_templates';
      break;
    case 5:
      target = 'main_skins';
      break;
    default:
      target = '';
  }

  return `/${this.basePath}/${target}?category_id=${id}`;
}

function userPath(this: any, id: number) {
  return `/${this.basePath}/users/${id}`;
}

const cartoondrawUrls = {
  baseURL: CARTOON_DRAW_URL,
  basePath: 'cartoondraw',

  remoteUrl:    remoteUrl,
  categoryPath: categoryPath,
  userPath:     userPath
}

export default cartoondrawUrls;
